const toId = (test)=>Number.isNaN(parseInt(String(test), 10)) ? test : parseInt(String(test), 10);
export { toId };
